// frontend/src/services/publicService.js
import api from './api';

const getArtworkPublic = (id) => {
  return api.get(`/public/artworks?art_id=${id}`);
};

const getAllArtworks = (params = {}) => api.get('/public/artworks', { params });

const getArtworksOnSale = (params = {}) => api.get('/public/artworks-on-sale', { params });

const getTokenizedArt = (params = {}) => api.get('/public/tokenized_art', { params });

export default {
  getArtworkPublic,
  getAllArtworks,
  getArtworksOnSale,
  getTokenizedArt,
};